import { routes } from 'utils/routing';

import type { RawTab } from '../../types';

export const id: RawTab['id'] = 'earn';

export const link: RawTab['link'] = {
  en: routes.redeem,
  fr: routes.redeem,
};
